<template>
    <div class="calls-result">
      <div class="table-responsive">
        <table class="table is-bordered is-striped is-narrow">
<!--          <thead>-->
<!--          <tr>-->
<!--            <th>Состояние</th>-->
<!--            <th>Количество</th>-->
<!--          </tr>-->
<!--          </thead>-->
          <tbody>
            <tr>
              <td>Контактов в базе</td>
              <td>{{result.fullCount}}</td>
            </tr>
            <tr>
              <td>Дозвонились до</td>
              <td>{{result.predefinedCount}}</td>
            </tr>
            <tr>
              <td>Ответили на первый вопрос</td>
              <td>{{result.firstQuestionAnsweredCount}}</td>
            </tr>
            <tr>
              <td>Сценарий завершён</td>
              <td>{{result.dialogToEndCount}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
    import VisCommon from '../components/VisCommon'
    import {mapGetters} from 'vuex'

    const CAMPAIGNS_API = '/api/campaigns'

    export default {
        name: 'CampaignCallsResult',
        extends: VisCommon,
        components: {

        },
        props: ['id'],
        data: function () {
          return {
            result: {
               fullCount: '',
               predefinedCount: '',
               firstQuestionAnsweredCount: '',
               dialogToEndCount: ''
            }
          }
        },
        created () {
          this.loadResults()
        },
        computed: {
          ...mapGetters([
            'authenticationToken',
            'loggedId'
          ])
        },
        methods: {
          loadResults() {
            this.$http.get(CAMPAIGNS_API + '/getCallsResult/' + this.$props.id, {headers: this.prepareSecurityHeader()})
              .then((response) => {
                this.result = response.data
              })
              .catch((error) => {
                console.log(error)
              })
          }
        }
    }
</script>

<style scoped>
 .calls-result {
   max-width: 300px;
 }
</style>



// WEBPACK FOOTER //
// CampaignCallsResult.vue?8a183e38